export const FETCH_SPA_ROOM = "FETCH_SPA_ROOM"
